import { EntityTemplateVariables, TemplateVariable } from '@tools/interfaces/template';
import { templateContactRelation } from './template-contact-relation';

export const getContactFieldsForEntity = (entity: string): TemplateVariable[] => {
  return [
    {
      label: 'templates.contacts.fullname.label',
      contentValue: `{{ ${entity}contact.fullname }}`,
      description: 'templates.contacts.fullname.description',
    },
    {
      label: 'templates.contacts.code.label',
      contentValue: `{{ ${entity}contact.code }}`,
      description: 'templates.contacts.code.description',
    },
    {
      label: 'templates.contacts.status.label',
      contentValue: `{{ ${entity}contact.status }}`,
      description: 'templates.contacts.status.description',
    },
    {
      label: 'templates.contacts.type.label',
      contentValue: `{{ ${entity}contact.type }}`,
      description: 'templates.contacts.type.description',
    },
    {
      label: 'templates.contacts.insurance.label',
      contentValue: `{{ ${entity}contact.insurance }}`,
      description: 'templates.contacts.insurance.description',
    },
    {
      label: 'templates.contacts.belongs_to_federation.label',
      contentValue: `{{ ${entity}contact.belongs_to_federation }}`,
      description: 'templates.contacts.belongs_to_federation.description',
    },
    {
      label: 'templates.contacts.competition_type.label',
      contentValue: `{{ ${entity}contact.competition_type }}`,
      description: 'templates.contacts.competition_type.description',
    },
    {
      label: 'templates.contacts.language.label',
      contentValue: `{{ ${entity}contact.language }}`,
      description: 'templates.contacts.language.description',
    },
    {
      label: 'templates.contacts.vat_number.label',
      contentValue: `{{ ${entity}contact.vat_number }}`,
      description: 'templates.contacts.vat_number.description',
    },
    {
      label: 'templates.contacts.start_date.label',
      contentValue: `{{ ${entity}contact.start_date | date("d/m/Y") }}`,
      description: 'templates.contacts.start_date.description',
    },
    {
      label: 'templates.contacts.end_date.label',
      contentValue: `{{ ${entity}contact.end_date | date("d/m/Y") }}`,
      description: 'templates.contacts.end_date.description',
    },
    {
      label: 'templates.contacts.iban_number.label',
      contentValue: `{{ ${entity}contact.iban_number }}`,
      description: 'templates.contacts.iban_number.description',
    },
    {
      label: 'templates.contacts.bic_number.label',
      contentValue: `{{ ${entity}contact.bic_number }}`,
      description: 'templates.contacts.bic_number.description',
    },
    {
      label: 'templates.contacts.bank_account_name.label',
      contentValue: `{{ ${entity}contact.bank_account_name }}`,
      description: 'templates.contacts.bank_account_name.description',
    },
    {
      label: 'templates.contacts.comment.label',
      contentValue: `{{ ${entity}contact.comment }}`,
      description: 'templates.contacts.comment.description',
    },
    {
      label: 'templates.contacts.juridic_form.label',
      contentValue: `{{ ${entity}contact.juridic_form }}`,
      description: 'templates.contacts.juridic_form.description',
    },
    {
      label: 'templates.contacts.job_title.label',
      contentValue: `{{ ${entity}contact.job_title }}`,
      description: 'templates.contacts.job_title.description',
    },
    {
      label: 'templates.contacts.height.label',
      contentValue: `{{ ${entity}contact.height }}`,
      description: 'templates.contacts.height.description',
    },
    {
      label: 'templates.contacts.weight.label',
      contentValue: `{{ ${entity}contact.weight }}`,
      description: 'templates.contacts.weight.description',
    },
    {
      label: 'templates.contacts.feet_size.label',
      contentValue: `{{ ${entity}contact.feet_size }}`,
      description: 'templates.contacts.feet_size.description',
    },
    {
      label: 'templates.contacts.clothes_size.label',
      contentValue: `{{ ${entity}contact.clothes_size }}`,
      description: 'templates.contacts.clothes_size.description',
    },
    {
      label: 'templates.contacts.short_name.label',
      contentValue: `{{ ${entity}contact.short_name }}`,
      description: 'templates.contacts.short_name.description',
    },
    {
      label: 'templates.contacts.color.label',
      contentValue: `{{ ${entity}contact.color }}`,
      description: 'templates.contacts.color.description',
    },
    {
      label: 'templates.contacts.full_address.label',
      contentValue: `{{ ${entity}contact.full_address }}`,
      description: 'templates.contacts.full_address.description',
    },
  ];
};
export const getContactIndividualFieldsForEntity = (entity: string): TemplateVariable[] => {
  return [
    {
      label: 'templates.contacts.contact_individual.firstname.label',
      contentValue: `{{ ${entity}contact.contactIndividual.firstname }}`,
      description: 'templates.contacts.contact_individual.firstname.description',
    },
    {
      label: 'templates.contacts.contact_individual.lastname.label',
      contentValue: `{{ ${entity}contact.contactIndividual.lastname }}`,
      description: 'templates.contacts.contact_individual.lastname.description',
    },
    {
      label: 'templates.contacts.contact_individual.birthdate.label',
      contentValue: `{{ ${entity}contact.contactIndividual.birthdate | date("d/m/Y") }}`,
      description: 'templates.contacts.contact_individual.birthdate.description',
    },
    {
      label: 'templates.contacts.contact_individual.gender.label',
      contentValue: `{{ ${entity}contact.contactIndividual.gender }}`,
      description: 'templates.contacts.contact_individual.gender.description',
    },
    {
      label: 'templates.contacts.contact_individual.title.label',
      contentValue: `{{ ${entity}contact.contactIndividual.title }}`,
      description: 'templates.contacts.contact_individual.title.description',
    },
    {
      label: 'templates.contacts.contact_individual.nationality.label',
      contentValue: `{{ ${entity}contact.contactIndividual.nationality }}`,
      description: 'templates.contacts.contact_individual.nationality.description',
    },
    {
      label: 'templates.contacts.contact_individual.id_card_number.label',
      contentValue: `{{ ${entity}contact.contactIndividual.id_card_number }}`,
      description: 'templates.contacts.contact_individual.id_card_number.description',
    },
    {
      label: 'templates.contacts.contact_individual.passport_number.label',
      contentValue: `{{ ${entity}contact.contactIndividual.passport_number }}`,
      description: 'templates.contacts.contact_individual.passport_number.description',
    },
    {
      label: 'templates.contacts.contact_individual.registration_number.label',
      contentValue: `{{ ${entity}contact.contactIndividual.registration_number }}`,
      description: 'templates.contacts.contact_individual.registration_number.description',
    },
    {
      label: 'templates.contacts.contact_individual.birth_city.label',
      contentValue: `{{ ${entity}contact.contactIndividual.birth_city }}`,
      description: 'templates.contacts.contact_individual.birth_city.description',
    },
    {
      label: 'templates.contacts.contact_individual.birth_country.label',
      contentValue: `{{ ${entity}contact.contactIndividual.birth_country }}`,
      description: 'templates.contacts.contact_individual.birth_country.description',
    },
    {
      label: 'templates.contacts.contact_individual.death_date.label',
      contentValue: `{{ ${entity}contact.contactIndividual.death_date | date("d/m/Y") }}`,
      description: 'templates.contacts.contact_individual.death_date.description',
    },
  ];
};
export const getContactDetailFieldsForEntity = (entity: string): TemplateVariable[] => {
  return [
    {
      label: 'templates.contacts.contact_detail.street.label',
      contentValue: `{{ ${entity}contact.contactDetail.street }}`,
      description: 'templates.contacts.contact_detail.street.description',
    },
    {
      label: 'templates.contacts.contact_detail.street2.label',
      contentValue: `{{ ${entity}contact.contactDetail.street2 }}`,
      description: 'templates.contacts.contact_detail.street2.description',
    },
    {
      label: 'templates.contacts.contact_detail.zip.label',
      contentValue: `{{ ${entity}contact.contactDetail.zip }}`,
      description: 'templates.contacts.contact_detail.zip.description',
    },
    {
      label: 'templates.contacts.contact_detail.city.label',
      contentValue: `{{ ${entity}contact.contactDetail.city }}`,
      description: 'templates.contacts.contact_detail.city.description',
    },
    {
      label: 'templates.contacts.contact_detail.country.label',
      contentValue: `{{ ${entity}contact.contactDetail.country }}`,
      description: 'templates.contacts.contact_detail.country.description',
    },
    {
      label: 'templates.contacts.contact_detail.phone1.label',
      contentValue: `{{ ${entity}contact.contactDetail.phone1 }}`,
      description: 'templates.contacts.contact_detail.phone1.description',
    },
    {
      label: 'templates.contacts.contact_detail.phone2.label',
      contentValue: `{{ ${entity}contact.contactDetail.phone2 }}`,
      description: 'templates.contacts.contact_detail.phone2.description',
    },
    {
      label: 'templates.contacts.contact_detail.phone3.label',
      contentValue: `{{ ${entity}contact.contactDetail.phone3 }}`,
      description: 'templates.contacts.contact_detail.phone3.description',
    },
    {
      label: 'templates.contacts.contact_detail.email1.label',
      contentValue: `{{ ${entity}contact.contactDetail.email1 }}`,
      description: 'templates.contacts.contact_detail.email1.description',
    },
    {
      label: 'templates.contacts.contact_detail.email2.label',
      contentValue: `{{ ${entity}contact.contactDetail.email2 }}`,
      description: 'templates.contacts.contact_detail.email2.description',
    },
    {
      label: 'templates.contacts.contact_detail.website.label',
      contentValue: `{{ ${entity}contact.contactDetail.website }}`,
      description: 'templates.contacts.contact_detail.website.description',
    },
  ];
};
export const getContactGlobalFieldsForEntity = (entity: string): TemplateVariable[] => {
  return [
    ...getContactFieldsForEntity(entity),
    ...getContactIndividualFieldsForEntity(entity),
    ...getContactDetailFieldsForEntity(entity),
  ];
};

export const templateContact: EntityTemplateVariables = {
  fields: getContactFieldsForEntity(''),
  related: [
    {
      relationName: 'contactDetail',
      relationType: 'simple',
      label: 'templates.contacts.contact_detail.label',
      description: 'templates.contacts.contact_detail.description',
      fields: [
        {
          label: 'templates.contacts.contact_detail.street.label',
          contentValue: `{{ contact.contactDetail.street }}`,
          description: 'templates.contacts.contact_detail.street.description',
        },
        {
          label: 'templates.contacts.contact_detail.street2.label',
          contentValue: `{{ contact.contactDetail.street2 }}`,
          description: 'templates.contacts.contact_detail.street2.description',
        },
        {
          label: 'templates.contacts.contact_detail.zip.label',
          contentValue: `{{ contact.contactDetail.zip }}`,
          description: 'templates.contacts.contact_detail.zip.description',
        },
        {
          label: 'templates.contacts.contact_detail.city.label',
          contentValue: `{{ contact.contactDetail.city }}`,
          description: 'templates.contacts.contact_detail.city.description',
        },
        {
          label: 'templates.contacts.contact_detail.country.label',
          contentValue: `{{ contact.contactDetail.country }}`,
          description: 'templates.contacts.contact_detail.country.description',
        },
        {
          label: 'templates.contacts.contact_detail.phone1.label',
          contentValue: `{{ contact.contactDetail.phone1 }}`,
          description: 'templates.contacts.contact_detail.phone1.description',
        },
        {
          label: 'templates.contacts.contact_detail.phone2.label',
          contentValue: `{{ contact.contactDetail.phone2 }}`,
          description: 'templates.contacts.contact_detail.phone2.description',
        },
        {
          label: 'templates.contacts.contact_detail.phone3.label',
          contentValue: `{{ contact.contactDetail.phone3 }}`,
          description: 'templates.contacts.contact_detail.phone3.description',
        },
        {
          label: 'templates.contacts.contact_detail.email1.label',
          contentValue: `{{ contact.contactDetail.email1 }}`,
          description: 'templates.contacts.contact_detail.email1.description',
        },
        {
          label: 'templates.contacts.contact_detail.email2.label',
          contentValue: `{{ contact.contactDetail.email2 }}`,
          description: 'templates.contacts.contact_detail.email2.description',
        },
        {
          label: 'templates.contacts.contact_detail.website.label',
          contentValue: `{{ contact.contactDetail.website }}`,
          description: 'templates.contacts.contact_detail.website.description',
        },
      ],
    },
    {
      relationName: 'contactIndividual',
      relationType: 'simple',
      label: 'templates.contact.contact_individual.label',
      description: 'templates.contacts.contact_individual.description',
      fields: [
        {
          label: 'templates.contacts.contact_individual.firstname.label',
          contentValue: `{{ contact.contactIndividual.firstname }}`,
          description: 'templates.contacts.contact_individual.firstname.description',
        },
        {
          label: 'templates.contacts.contact_individual.lastname.label',
          contentValue: `{{ contact.contactIndividual.lastname }}`,
          description: 'templates.contacts.contact_individual.lastname.description',
        },
        {
          label: 'templates.contacts.contact_individual.birthdate.label',
          contentValue: `{{ contact.contactIndividual.birthdate | date("d/m/Y") }}`,
          description: 'templates.contacts.contact_individual.birthdate.description',
        },
        {
          label: 'templates.contacts.contact_individual.gender.label',
          contentValue: `{{ contact.contactIndividual.gender }}`,
          description: 'templates.contacts.contact_individual.gender.description',
        },
        {
          label: 'templates.contacts.contact_individual.title.label',
          contentValue: `{{ contact.contactIndividual.title }}`,
          description: 'templates.contacts.contact_individual.title.description',
        },
        {
          label: 'templates.contacts.contact_individual.nationality.label',
          contentValue: `{{ contact.contactIndividual.nationality }}`,
          description: 'templates.contacts.contact_individual.nationality.description',
        },
        {
          label: 'templates.contacts.contact_individual.id_card_number.label',
          contentValue: `{{ contact.contactIndividual.id_card_number }}`,
          description: 'templates.contacts.contact_individual.id_card_number.description',
        },
        {
          label: 'templates.contacts.contact_individual.passport_number.label',
          contentValue: `{{ contact.contactIndividual.passport_number }}`,
          description: 'templates.contacts.contact_individual.passport_number.description',
        },
        {
          label: 'templates.contacts.contact_individual.registration_number.label',
          contentValue: `{{ contact.contactIndividual.registration_number }}`,
          description: 'templates.contacts.contact_individual.registration_number.description',
        },
        {
          label: 'templates.contacts.contact_individual.birth_city.label',
          contentValue: `{{ contact.contactIndividual.birth_city }}`,
          description: 'templates.contacts.contact_individual.birth_city.description',
        },
        {
          label: 'templates.contacts.contact_individual.birth_country.label',
          contentValue: `{{ contact.contactIndividual.birth_country }}`,
          description: 'templates.contacts.contact_individual.birth_country.description',
        },
        {
          label: 'templates.contacts.contact_individual.death_date.label',
          contentValue: `{{ contact.contactIndividual.death_date | date("d/m/Y") }}`,
          description: 'templates.contacts.contact_individual.death_date.description',
        },
      ],
    },
    {
      relationName: 'contactOrganization',
      relationType: 'simple',
      label: 'templates.contact.contact_organization.label',
      description: 'templates.contact.contact_organization.description',
      fields: [
        {
          label: 'templates.contacts.contact_organization.type.label',
          contentValue: `{{ contact.contactOrganization.type }}`,
          description: 'templates.contacts.contact_organization.type.description',
        },
      ],
    },
  ],
  relatedInLoop: [
    {
      relationName: 'contactRelation',
      relationType: 'inLoop',
      label: 'templates.contacts.contact_relations.label',
      description: 'templates.contacts.contact_relations.description',
      blockStartValue: '{% for contactRelation in contact.contactRelations %}',
      contentValue: '{# Add some contactRelation fields #}',
      blockEndValue: '{% endfor %}',
      fields: templateContactRelation.fields,
    },
    {
      relationName: 'inverseContactRelation',
      relationType: 'inLoop',
      label: 'templates.contacts.inverse_contact_relations.label',
      description: 'templates.contacts.inverse_contact_relations.description',
      blockStartValue: '{% for contactRelation in contact.inverseContactRelations %}',
      contentValue: '{# Add some contactRelation fields #}',
      blockEndValue: '{% endfor %}',
      fields: templateContactRelation.fields,
    },
    {
      relationName: 'relatedContact',
      relationType: 'inLoop',
      label: 'templates.contacts.related_contacts.label',
      description: 'templates.contacts.related_contacts.description',
      blockStartValue: '{% for contactRelation in contact.contactRelations %}',
      contentValue: '{# Add some contactRelation fields #}',
      blockEndValue: '{% endfor %}',
      fields: getContactFieldsForEntity('contactRelation.relatedContact.'),
    },
    {
      relationName: 'inverseRelatedContact',
      relationType: 'inLoop',
      label: 'templates.contacts.inverse_related_contacts.label',
      description: 'templates.contacts.inverse_related_contacts.description',
      blockStartValue: '{% for inverseContactRelation in contact.inverseContactRelations %}',
      contentValue: '{# Add some contactRelation fields #}',
      blockEndValue: '{% endfor %}',
      fields: getContactFieldsForEntity('inverseContactRelation.contact.'),
    },
  ],
};
